import { render, staticRenderFns } from "./DeviceCategoryItem.vue?vue&type=template&id=772d1ebf&scoped=true&"
import script from "./DeviceCategoryItem.vue?vue&type=script&lang=ts&"
export * from "./DeviceCategoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceCategoryItem.vue?vue&type=style&index=0&id=772d1ebf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d1ebf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})
